import React from 'react'
import { useTranslation } from 'react-i18next'

const EmptyStateContainer = () => {
    const { t } = useTranslation();
  return (
    <>
            <div className="empty-state-container">
              <h5>{t("brak_nadchodzacych_rezerwacji")}</h5>
              <span className="text-size-body-small text-color-dark-gray">{t("wyglada_na_to_ze_nie_zapisales_sie_jeszcze_na_zadne_zajecia_ani_wydarzenie")}</span>
        
            </div>
          </>
  )
}

export default EmptyStateContainer
